import styled from 'styled-components'

import {media} from '@/src/config/theme'

import * as UI_ProductListItem from './product-list-item.styled'

export const ProductList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  padding-top: 20px;
  gap: 16px;
  width: 100%;
  align-items: stretch;

  & > ${UI_ProductListItem.ProductListItem} {
    width: 100%;

    @media ${media.md} {
      width: 100%;
    }
    @media ${media.lg} {
      width: 100%;
    }
  }

  @media ${media.lg} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
  }
`
